import { useState, useContext } from 'react';
import * as lodash from 'lodash';
import { useHistory } from 'react-router-dom';
import { ALERT_TYPES, AppContext, ERROR_SEVERITY } from 'commons-ui';
import useService from './useService';
import { Record } from './helper';

const delinkUserDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { delinkUserByPhone } = useService();

	const handleFormSubmit = async (submittedData: Record) => {
		setShowLoader(true);
		const { ZupeeUserId } = submittedData;
		try {
			if (!lodash.isString(ZupeeUserId) || lodash.isEmpty(ZupeeUserId.trim())) {
				showAlert('Invalid ZupeeUserId!!', { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			} else {
				const isRespSuccess: boolean = await delinkUserByPhone(ZupeeUserId, showAlert);
				if (isRespSuccess) {
					showAlert('ZupeeUserId submitted successfully', { type: ALERT_TYPES.SUCCESS });
				}
				setShowLoader(false);
			}
		} catch (error: any) {
			showAlert(error.error || 'Something went wrong', { type: ERROR_SEVERITY.ERROR });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};
export default delinkUserDetails;
